export default "__VITE_ASSET__Cr7eLK7O__"